import React from 'react';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center p-4">
            <div className="text-center max-w-md">
                <div className="text-7xl font-bold text-teal-500 mb-4">404</div>
                <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">Page Not Found</h1>
                <p className="text-gray-600 dark:text-gray-400 mb-8">
                    The page you're looking for doesn't exist or may have been moved.
                </p>
                <div className="flex flex-col sm:flex-row gap-3 justify-center">
                    <button
                        onClick={() => navigate('/')}
                        className="px-6 py-3 rounded-xl bg-gradient-to-r from-teal-500 to-cyan-500 text-white font-bold hover:opacity-90 transition-all"
                    >
                        Go to Homepage
                    </button>
                    <button
                        onClick={() => navigate('/pricing')}
                        className="px-6 py-3 rounded-xl bg-gray-200 dark:bg-gray-700 text-gray-900 dark:text-white font-semibold hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors"
                    >
                        View Pricing
                    </button>
                </div>
            </div>
        </div>
    );
};

export default NotFound;
